import {
  LabraVenturesTheme,
  labravDefaultThemeV7 as theme,
} from '@labrav/react-components'
import { Provider, store } from './store'
import { BrowserRouter } from 'react-router-dom'
import { FlagsProvider } from '@labrav/flags'
import {
  flagsCacheTTLSeconds,
  flagsUrl,
  serviceEnvironment,
  serviceId,
} from './common/utils/constants'
import './telemetry'
import OktaAndAuth0SecureApp from './common/pages/OktaAndAuth0SecureApp'
import devFlags from './flags/dev/flags.json'
import { TrackerProvider } from './common/utils/Tracker/TrackerProvider'
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles'
import { LongTaskMonitor } from './LongTaskMonitor'
import { WithErrorBoundary } from './common/components/WithErrorBoundary/WithErrorBoundary'
import {
  AuthPolicyProvider,
  AuthorizationScopesSync,
  gatekeeperPolicyEngine,
} from './common/modules/authorization'

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends LabraVenturesTheme {}
}

function App() {
  const analytics = typeof window !== 'undefined' && window.analytics

  return (
    <Provider store={store}>
      <AuthPolicyProvider policyEngine={gatekeeperPolicyEngine}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <FlagsProvider
              env={serviceEnvironment}
              flagsUrl={flagsUrl}
              service={serviceId}
              cacheTtlSeconds={flagsCacheTTLSeconds}
              flagsJson={import.meta.env.DEV ? devFlags : undefined}
            >
              <TrackerProvider analytics={analytics || undefined}>
                <div className="App" style={{ height: '100%' }}>
                  <div className="page" style={{ height: '100%' }}>
                    <div className="content" style={{ height: '100%' }}>
                      <LongTaskMonitor />
                      <WithErrorBoundary boundary="App">
                        {/* Redux Provider is above; sync runs in useEffect (not every render). */}
                        <AuthorizationScopesSync />
                        <BrowserRouter
                          basename={import.meta.env.VITE_PUBLIC_URL}
                        >
                          <OktaAndAuth0SecureApp />
                        </BrowserRouter>
                      </WithErrorBoundary>
                    </div>
                  </div>
                </div>
              </TrackerProvider>
            </FlagsProvider>
          </ThemeProvider>
        </StyledEngineProvider>
      </AuthPolicyProvider>
    </Provider>
  )
}

export default App
